import { render, staticRenderFns } from "./TipoTalhaoList.vue?vue&type=template&id=745f47d6&scoped=true"
import script from "./TipoTalhaoList.vue?vue&type=script&lang=js"
export * from "./TipoTalhaoList.vue?vue&type=script&lang=js"
import style0 from "./TipoTalhaoList.vue?vue&type=style&index=0&id=745f47d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f47d6",
  null
  
)

export default component.exports